import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getCustomFormByName,
	getCustomFormByNameEndpoint,
	type QueryError,
	type GetCustomFormByNameResult,
	type GetCustomFormByNameRequestOptions,
} from '../getCustomFormByName';
export * from '../getCustomFormByName';

export type GetCustomFormByNameQueryParams = GetCustomFormByNameRequestOptions;
export type GetCustomFormByNameQueryKey = [
	string,
	GetCustomFormByNameQueryParams,
];

export type GetCustomFormByNameReactQueryOptions = Omit<
	UseQueryOptions<
		GetCustomFormByNameResult,
		QueryError,
		GetCustomFormByNameResult,
		GetCustomFormByNameQueryKey
	>,
	'queryKey' | 'queryFn'
> & {
	queryFn?: typeof getCustomFormByName;
};

export const GetCustomFormByNameReactQueryKey = getCustomFormByNameEndpoint;

/**
 * react-query wrapper for `getCustomFormByName`
 * @param queryKeyParams Params passed to the api call
 * @param options Options passed to `useQuery`
 */
export const useGetCustomFormByName = (
	queryKeyParams: GetCustomFormByNameQueryParams,
	{
		queryFn = getCustomFormByName,
		...options
	}: GetCustomFormByNameReactQueryOptions = {},
) =>
	useQuery<
		GetCustomFormByNameResult,
		QueryError,
		GetCustomFormByNameResult,
		GetCustomFormByNameQueryKey
	>({
		queryKey: [GetCustomFormByNameReactQueryKey, queryKeyParams],
		queryFn: ({signal}) => queryFn(queryKeyParams, signal),
		refetchOnWindowFocus: false,
		...options,
	});

export default useGetCustomFormByName;
